import createAssigner from './_createAssigner.js';
import allKeys from './allKeys.js';

// Fill in a given object with default properties.
export default createAssigner(allKeys, true);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.12.0@underscore/modules/defaults.js
// module id = 126
// module chunks = 20